import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "View.svg",
  "use": "View.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"View.svg\"><path d=\"M32.0057,48.0208c-14.676,0-21.9655-11.6723-23.78-15.0778a1.9569,1.9569,0,0,1,0-1.8444c1.8145-3.4055,9.104-15.0778,23.78-15.0778s21.9655,11.6723,23.78,15.0778a1.9557,1.9557,0,0,1,0,1.8444C53.9712,36.3485,46.6817,48.0208,32.0057,48.0208Zm.0151-27a11,11,0,1,0,11.0005,11A11,11,0,0,0,32.0208,21.02Zm0,18.0007a7,7,0,1,1,7-7A7,7,0,0,1,32.0208,39.0211Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol